import { IconContent } from '@icons';

export const vocabularies: IconContent = {
    md: '<path fill-rule="evenodd" d="m17.113 4.54-2.954.521.328 1.863 2.955-.52-.329-1.864Zm.502 2.848-2.954.52 1.755 9.956 2.955-.521-1.756-9.955Zm-3.939.694 1.755 9.955.17.963H13V4H4v15H3v1h18v-1h-5.27l.86-.152 2.954-.52.985-.174-.174-.985-2.257-12.802-.174-.985-.985.173-2.954.521L13 4.25l.174.985.328 1.863H13.5l.174.985h.002ZM5 5h3v2H5V5Zm7 2V5H9v2h3ZM9 8h3v11H9V8ZM8 8v11H5V8h3Z" />',
};
